export const STAT_KEYS = ['e', 'x', 'u', 'p'];

export const STAT_META = {
  e: { label: 'Engineering trust', short: 'Eng',    color: '#4CEB9F' },
  x: { label: 'Exec confidence',   short: 'Exec',   color: '#6B53FD' },
  u: { label: 'User impact',       short: 'Impact', color: '#EF7E46' },
  p: { label: 'Personal energy',   short: 'Energy', color: '#FDBC45' },
};

export const TOTAL_DAYS = 60;
export const SWIPE_THRESHOLD = 110;
export const TILT_RANGE = 18;
export const TINT_RANGE = 0.35;

export const SAVE_KEY = 'thenewpm.v1';
